(function(angular) {
    'use strict';

    angular.module('profiles')
    .factory('profileData', [function () {
        var profile;
        var configuredProfile;
        var configuredProfiles;
        var fac = {
            profile: profile,
            cofiguredProfile: configuredProfile,
            configuredProfiles: configuredProfiles
        };

        return fac;
    }]);

})(window.angular);
